var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        open: _vm.welcomeWesave && !_vm.isAdvisor,
        sidebar: true,
        "hide-close": false,
        "hide-scroll": ""
      },
      on: { close: _vm.onClose }
    },
    [
      _c("template", { slot: "sidebar" }, [
        _c("img", {
          staticClass: "pub-modal-img",
          attrs: { src: _vm.bestImageRatio("/static/club-modal") }
        })
      ]),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "pub-welcome-modal" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("devices.welcome-modal.title")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("devices.welcome-modal.content")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("devices.welcome-modal.list.title")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(_vm._s(_vm.$t("devices.welcome-modal.list.contracts")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("devices.welcome-modal.list.real-estates")))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("devices.welcome-modal.list.savings")))
            ]),
            _vm._v(" "),
            !_vm.isESROnboardingOrigin
              ? _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("devices.welcome-modal.list.consultations"))
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-button" },
            [
              !_vm.isESROnboardingOrigin
                ? _c(
                    "x-button",
                    {
                      staticClass: "md-raised md-primary",
                      on: { click: _vm.resendValidation }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("devices.welcome-modal.button")) +
                          "\n      "
                      )
                    ]
                  )
                : _c(
                    "x-button",
                    {
                      staticClass: "md-raised md-primary",
                      on: { click: _vm.upgradeAccountFeaturesClick }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("devices.welcome-modal.button-access")
                          ) +
                          "\n      "
                      )
                    ]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "link", on: { click: _vm.goToLandingPage } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("devices.welcome-modal.link")) +
                  "\n    "
              )
            ]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }